import lazySizes
	from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import GLightbox
	from 'glightbox';

import {
	$Elements,
	BrowserEvents
} from './constants';
import {
	addExternalScript,
	fixMobileHover
} from './helpers';
import {
	calculateMenuOffset
} from './menu';

// ---------- LazyLoad Config ----------

lazySizes.cfg.throttleDelay = 66;
lazySizes.cfg.preloadAfterLoad = true;

// ---------- jQuery Related ----------

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		addExternalScript('<script id="regiondo-button-js" src="https://cdn.regiondo.net/js/integration/regiondo-button.js"></script>')

		// ---------- Fix VH ----------

		$Elements.window.on('resize', () => document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`));
		$Elements.window.trigger('resize');

		// ---------- Fix Mobile Hover ----------
		$Elements.window.on('load', () => fixMobileHover());
		// fixMobileHover();

		// ---------- Handle lazyload ----------

		$Elements.document.on('lazyloaded', () => $Elements.window.trigger('resize'));

		// ---------- Links ----------

		$('a[href="#"], .void-link').click((e) => e.preventDefault());

		$('[data-scroll-to]').click(function(e) {
			e.preventDefault();

			const self = $(this);
			const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

			if(target.length) {

				$('html, body').stop().animate({
					scrollTop: calculateMenuOffset(target)
				}, 1000);
			}
		});

		$('.select-dropdown .dropdown-menu .btn').click(function() {
			$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).text());
		});

		$('.newsletter-link').each(function() {

			GLightbox({
				selector:    'a.newsletter-link',
				openEffect:  'fade',
				closeEffect: 'fade',
				skin:        'clean newsletter',
				height:      'auto',
				width:       600,
			});
		});

		$('[target="lightbox"]').each(function() {

			GLightbox({
				selector:    'a[href="' + this.attributes.href.value + '"][target="lightbox"]',
				openEffect:  'fade',
				closeEffect: 'fade',
				videosWidth: 1280,
			});
		});

		$('[target^="lightbox-gallery"]').each(function() {

			GLightbox({
				selector:    'a[target="' + this.attributes.target.value + '"]',
				openEffect:  'fade',
				closeEffect: 'fade',
				videosWidth: 1280,
			});
		});

		// ---------- Circle Progress ----------

		$('.progress.progress-circle').each(function() {

			const value = this.dataset.value;
			const left = $(this).find('.progress-left .progress-bar');
			const right = $(this).find('.progress-right .progress-bar');
			const percentageToDegrees = percentage => percentage / 100 * 360;

			if(value > 0) {

				if(value <= 50) {
					right.css('transform', 'rotate(' + percentageToDegrees(value) + 'deg)')
				}
				else {
					right.css('transform', 'rotate(180deg)')
					left.css('transform', 'rotate(' + percentageToDegrees(value - 50) + 'deg)')
				}
			}
		});
	});
}(jQuery));
